module.exports = "/images/833fdc87b48b2102c8dc43a93fd13347.png";